import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="pointer-events-none absolute bottom-10 select-none text-[8rem] font-black text-background-200 md:text-[12rem]">
        404
      </h1>
      <div className="relative z-10">
        <span className="flex items-center justify-center gap-2 text-sm font-bold text-primary-600">
          <i className="ri-emotion-sad-line text-lg" aria-hidden="true" />
          页面走丢了
        </span>
        <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">你要找的漫画可能已经大结局了</h2>
        <p className="mt-3 text-base text-foreground-600">
          不如回首页继续追更？每天都有新作品在等你。
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-line" aria-hidden="true" />
          返回首页
        </Link>
      </div>
    </div>
  );
}